import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  NavLink,
} from "react-router-dom";
import { Helmet } from "react-helmet";
import About from "./About";
import Art from "./Art";
import Success from "./Success";

function NavLinks() {
  return (
    <nav style={{ display: "flex", gap: "12px" }}>
      <NavLink
        to="/art"
        className={({ isActive }) => (isActive ? "active" : "inactive")}
      >
        art
      </NavLink>
      <NavLink
        to="/"
        end
        className={({ isActive }) => (isActive ? "active" : "inactive")}
      >
        about
      </NavLink>
    </nav>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Helmet>
          <link
            rel="alternate"
            hrefLang="x-default"
            href="https://felixingla.com"
          />
        </Helmet>
        <div className="App-content">
          <header>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <h1>Felix Ingla</h1>
              <div style={{ flex: "1 0 0", display: "flex" }}></div>
              <NavLinks />
            </div>
          </header>
          <Routes>
            <Route path="/" element={<About />} />
            <Route path="/art" element={<Art />} />
            <Route path="/art/:piece" element={<Art />} />
            <Route path="/success" element={<Success />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
